module.exports = __webpack_public_path__ + "img/Overton Johnson.6533abfb.jpg";